// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"739dd6fb","127":"78bab579","252":"364e3be0","284":"ac5120af","369":"7456895f","382":"80c0aebc","389":"8b14437a","554":"ee9271e8","607":"7db1ed99","734":"e821905e","856":"bee94fe1","899":"7b918458","939":"829c9385"}[chunkId] + ".chunk.js";
};